<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="piv"></a>© 2014 Bruce K. Waltke, James M. Houston, and Erika Moore</p>
<p class="crt">All rights reserved</p>
<p class="crtf">Published 2014 by</p>
<p class="crt">Wm. B. Eerdmans Publishing Co.</p>
<p class="crt">2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /</p>
<p class="crt">P.O. Box 163, Cambridge CB3 9PU U.K.</p>
<p class="cipf"><b>Library of Congress Cataloging-in-Publication Data</b></p>
<p class="cipf">Waltke, Bruce K.</p>
<p class="cip">The Psalms as Christian lament: a historical commentary /</p>
<p class="cip">Bruce K. Waltke, James M. Houston, and Erika Moore.</p>
<p class="cip">pages cm</p>
<p class="cip">Includes bibliographical references and index.</p>
<p class="cip">ISBN 978-0-8028-6809-1 (pbk.: alk. paper); 978-1-4674-4064-6 (ePub); 978-1-4674-4022-6 (Kindle)</p>
<p class="cip">1. Bible. Psalms — Criticism, interpretation, etc.</p>
<p class="cip">2. Laments in the Bible.</p>
<p class="cip">I. Title.</p>
<p class="cipf">BS1445.L3W35 2014</p>
<p class="cip">223′.206 — dc23</p>
<p class="cip1">2013048119</p>
<p class="crtf"><a class="url" href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-psalmschristian-0004.vue?ae395706